import React from 'react';
import PropTypes from 'prop-types';

const BlogDetailCard = ({ heading, image, description }) => {
  return (
    <section className="w-full py-10 px-4 md:px-20">
      <div className="flex flex-col md:flex-col items-center">
        {/* Image Section - Takes 2/3 width on larger screens and full width on smaller screens */}
        <img
          className="w-full h-auto object-cover rounded-xl mb-10 shadow-lg"
          src={image}
          alt={heading}
        />

        {/* Text Section - Takes full width */}
        <div className="w-full text-center md:text-left px-6">
          <h2 className="font-bold text-2xl md:text-4xl mb-4 text-gray-800">
            {heading}
          </h2>
          <p className="text-md md:text-xl text-gray-600 leading-relaxed text-justify">
            {description}
          </p>
        </div>
      </div>
    </section>
  );
};

BlogDetailCard.propTypes = {
  heading: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default BlogDetailCard;
